import { Row, Text } from 'components';
import { theme } from 'lib';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const ArticleContainer = styled.div`
  margin: 0 40px 0 0;
  z-index: 3;
  width: 700px;
  cursor: pointer;

  @media (max-width: 1024px) {
    width: 520px;
    margin: 0 30px 0 0;
  }
`;

const Image = styled.div`
  background-image: url(${(props) => props.img});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 330px;
  width: 330px;
  margin: ${(props) => (props.first ? '0 40px 0 0' : '0')};

  @media (max-width: 1024px) {
    margin: ${(props) => (props.first ? '0 30px 0 0' : '0')};
    height: 240px;
    width: 240px;
  }
`;

const TextContainer = styled.div`
  margin-top: 8px;
  text-overflow: ellipsis;

  h3 {
    font-size: 24px;
    font-weight: 500;
    color: ${theme.SECONDARY};
  }

  h2  {
    font-size: 36px;
    color: #fff;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  @media (max-width: 1024px) {
    margin-top: 8px;

    h3 {
      font-size: 16px;
    }

    h2  {
      font-size: 24px;
    }
  }
`;

const NewsItem = ({ item }) => {
  const navigate = useNavigate();

  return (
    <ArticleContainer onClick={() => navigate(`articles/${item._id}`)}>
      <Row>
        <Image first={true} img={item?.images?.mainMed || require('assets/images/pogba.png')} />

        <Image img={item?.images?.secondaryMed || require('assets/images/pogba.png')} />
      </Row>

      <TextContainer>
        <Text h3>{item.sport}</Text>

        <Text h2>{item.title}</Text>
      </TextContainer>
    </ArticleContainer>
  );
};

export default NewsItem;
